import Header from "../Header";
import About from "../About";
import Features from "../Features";
import Screenshots from "../Screenshots";
import Download from "../Download";
import Privacy from "../Privacy";

const Home = () => {
	return (
		<>
			<Header />
			<About />
			<Features />
			<Screenshots />
			<Download />
			<Privacy />
		</>
	);
};
export default Home;
